import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21d0fc73&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=21d0fc73&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=21d0fc73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0fc73",
  null
  
)

export default component.exports